module.exports = __webpack_public_path__ + "static/media/_LOGO_NORMAL.999216ea.svg";